import { Button } from "@op/opds.opux";
import { IconDownload } from "@op/opds.opux-icons/action";
import { createRef, useCallback } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { useReferenceNumbers } from "../../providers/ReferenceNumberProvider";

type DownloadButtonProps = {
  data: string;
};
const DownloadButton = ({ data }: DownloadButtonProps) => {
  const ref = createRef<HTMLAnchorElement>();
  const { base } = useReferenceNumbers();
  const { formatMessage } = useIntl();
  const filename = (
    formatMessage({ id: "references" }) +
    "_" +
    base
  ).toLowerCase();

  const handleClick = useCallback(() => {
    const anchor = ref.current!;
    anchor.setAttribute("href", "data:text/plain;charset=utf-8," + data);
    anchor.setAttribute("download", filename);
    anchor.click();
    anchor.setAttribute("href", "/");
    anchor.removeAttribute("download");
  }, [filename, ref, data]);

  return (
    <>
      <Button
        compact
        icon={IconDownload}
        className="save-button"
        onClick={handleClick}
      >
        <FormattedMessage id="save" />
      </Button>
      <a
        ref={ref}
        href="/"
        target="_blank"
        style={{ display: "none" }}
      >
        <FormattedMessage id="save" />
      </a>
    </>
  );
};

export default DownloadButton;
